import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = true;
    }
  }

  show(event) {
    event.preventDefault();
    this.panelTarget.hidden = false;
  }

  hide(event) {
    event.preventDefault();
    this.panelTarget.hidden = true;
  }
}
